import React, { FC } from 'react';

import { Grid } from '@chakra-ui/react';

import { MetadataCommonFields } from 'containers/ActiveCloudResource/Components/ResourceMetadataDrawer/Components/MetadataCommonFields';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';

import {
  AgentCoreRuntimeIdleSessionTimeout,
  AgentCoreRuntimeMaxLifetime,
  AgentCoreRuntimeNetworkMode,
  AgentCoreRuntimeSecurityGroups,
  AgentCoreRuntimeServerProtocol,
  AgentCoreRuntimeSubnets,
  AgentCoreRuntimeVersion,
  AgentCoreRuntimeWorkloadIdentityARN,
  IAMRoleARN,
  UpdatedAt,
} from '../../../../Components/MetadataField/MetaGridFields';

export const AWSBedrockAgentCoreRuntimeMetadata: FC = () => {
  const { resourceDetails, resourceInsight } = useActiveResourceContext();
  const { data: resource } = resourceDetails;
  const { data: insight } = resourceInsight;
  const metadata = { ...resource, ...insight };

  return (
    <Grid templateColumns="repeat(4, 1fr)" gap={4}>
      <MetadataCommonFields
        state={metadata}
        availabilityZone="None"
        vpc="None"
        owner="None"
        createdAt={metadata}
      />
      {UpdatedAt(metadata)}
      {AgentCoreRuntimeVersion(metadata)}
      {AgentCoreRuntimeServerProtocol(metadata)}
      {AgentCoreRuntimeIdleSessionTimeout(metadata)}
      {AgentCoreRuntimeMaxLifetime(metadata)}
      {AgentCoreRuntimeNetworkMode(metadata)}
      {AgentCoreRuntimeWorkloadIdentityARN(metadata)}
      {IAMRoleARN(metadata)}
      {AgentCoreRuntimeSubnets(metadata)}
      {AgentCoreRuntimeSecurityGroups(metadata)}
    </Grid>
  );
};
